import { cva } from "class-variance-authority";

export const badgeVariants = cva(
  "inline-flex items-center rounded-full border border-border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-primary text-primary-foreground hover:bg-primary/80",
        secondary:
          "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
        destructive:
          "border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80",
        outline: "text-foreground",
        beta: "border-transparent bg-status-beta text-white font-mono text-xs",
        alpha:
          "border-transparent bg-status-alpha text-white font-mono text-xs",
        new: "border-transparent bg-status-new text-white font-mono text-xs",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
);
